import enStrings from "locales/en.json";

export const LOCALE_STRINGS = {
  ...enStrings,
};
